export interface AuditLogEntity {

    id: number | null,

    proposalNo: string | null,

    opsLine: string | null,

    cntrNo: string | null,

    chargeType: string | null,

    subChargeType: string | null,

    shippingBill: string | null,

    billOfLading: string | null,

    forwarderCode: string | null,

    userId: string | null,

    dtlStateBf: string | null,

    dtlStateAf: string | null,

    billToCompanyBf: string | null,

    billToCompanyAf: string | null,

    chargeOnCompanyBf: string | null,

    chargeOnCompanyAf: string | null,

    companyCodeBf: string | null,

    companyCodeAf: string | null,

    priorityBf: number | null,

    priorityAf: number | null,

    statusBf: string | null,

    statusAf: string | null,

    ownerBf: string | null,

    ownerAf: string | null,

    effectiveDateFromBf: Date | null,

    effectiveDateFromAf: Date | null,

    effectiveDateToBf: Date | null,

    effectiveDateToAf: Date | null,

    consortiumCodeBf: string | null,

    consortiumCodeAf: string | null,

    serviceCodeBf: string | null,

    serviceCodeAf: string | null,

    forwarderCodeBf: string | null,

    forwarderCodeAf: string | null,

    agentCodeBf: string | null,

    agentCodeAf: string | null,

    cargoCodeBf: string | null,

    cargoCodeAf: string | null,

    fspCountingFromBf: string | null,

    fspCountingFromAf: string | null,

    fspCountingToBf: string | null,

    fspCountingToAf: string | null,

    graceHourToBf: number | null,

    graceHourToAf: number | null,

    graceHourFromBf: number | null,

    graceHourFromAf: number | null,

    graceMinuteToBf: number | null,

    graceMinuteToAf: number | null,

    graceMinuteFromBf: number | null,

    graceMinuteFromAf: number | null,

    shipmentTypeBf: string | null,

    shipmentTypeAf: string | null,

    fspCountingDirectionBf: string | null,

    fspCountingDirectionAf: string | null,

    firstTierFspBf: number | null,

    firstTierFspAf: number | null,

    fspUomBf: string | null,

    fspUomAf: string | null,

    chargeTypeBf: string | null,

    chargeTypeAf: string | null,

    subChargeTypeBf: string | null,

    subChargeTypeAf: string | null,

    cntrMovementBf: string | null,

    cntrMovementAf: string | null,

    cntrStatusBf: string | null,

    cntrStatusAf: string | null,

    customerTypeBf: string | null,

    customerTypeAf: string | null,

    forwarderReferenceBf: string | null,

    forwarderReferenceAf: string | null,

    fspCalculateMethodBf: string | null,

    fspCalculateMethodAf: string | null,

    vesselCodeBf: string | null,

    vesselCodeAf: string | null,

    voyageCodeBf: string | null,

    voyageCodeAf: string | null,

    applyCalendarAdjBf: string | null,

    applyCalendarAdjAf: string | null,

    splitFirstDaysBf: number | null,

    splitFirstDaysAf: number | null,

    splitFirstDaysToBf: string | null,

    splitFirstDaysToAf: string | null,

    splitRemainDaysToBf: string | null,

    splitRemainDaysToAf: string | null,

    rejectReasonBf: string | null,

    rejectReasonAf: string | null,

    remarksBf: string | null,

    remarksAf: string | null,

    graceExtendBf: string | null,

    graceExtendAf: string | null,

    activeIndBf: string | null,

    activeIndAf: string | null,

    draftDocNoBf: string | null,

    draftDocNoAf: string | null,

    docNoBf: string | null,

    docNoAf: string | null,

    receiptNoBf: string | null,

    receiptNoAf: string | null,

    auditLogType: string | null,

    auditLogIncident: string | null,

    updatedDateTime: Date | null,

    [key: string]: string | number | null | undefined | Object
}

export const EMPTY_AUDIT_LOG_ENTITY: AuditLogEntity = {
    id: null,
    proposalNo: null,
    opsLine: null,
    cntrNo: null,
    chargeType: null,
    subChargeType: null,
    shippingBill: null,
    billOfLading: null,
    forwarderCode: null,
    userId: null,
    dtlStateBf: null,
    dtlStateAf: null,
    billToCompanyBf: null,
    billToCompanyAf: null,
    chargeOnCompanyBf: null,
    chargeOnCompanyAf: null,
    companyCodeBf: null,
    companyCodeAf: null,
    priorityBf: null,
    priorityAf: null,
    statusBf: null,
    statusAf: null,
    ownerBf: null,
    ownerAf: null,
    effectiveDateFromBf: null,
    effectiveDateFromAf: null,
    effectiveDateToBf: null,
    effectiveDateToAf: null,
    consortiumCodeBf: null,
    consortiumCodeAf: null,
    serviceCodeBf: null,
    serviceCodeAf: null,
    forwarderCodeBf: null,
    forwarderCodeAf: null,
    agentCodeBf: null,
    agentCodeAf: null,
    cargoCodeBf: null,
    cargoCodeAf: null,
    fspCountingFromBf: null,
    fspCountingFromAf: null,
    fspCountingToBf: null,
    fspCountingToAf: null,
    graceHourToBf: null,
    graceHourToAf: null,
    graceHourFromBf: null,
    graceHourFromAf: null,
    graceMinuteToBf: null,
    graceMinuteToAf: null,
    graceMinuteFromBf: null,
    graceMinuteFromAf: null,
    shipmentTypeBf: null,
    shipmentTypeAf: null,
    fspCountingDirectionBf: null,
    fspCountingDirectionAf: null,
    firstTierFspBf: null,
    firstTierFspAf: null,
    fspUomBf: null,
    fspUomAf: null,
    chargeTypeBf: null,
    chargeTypeAf: null,
    subChargeTypeBf: null,
    subChargeTypeAf: null,
    cntrMovementBf: null,
    cntrMovementAf: null,
    cntrStatusBf: null,
    cntrStatusAf: null,
    customerTypeBf: null,
    customerTypeAf: null,
    forwarderReferenceBf: null,
    forwarderReferenceAf: null,
    fspCalculateMethodBf: null,
    fspCalculateMethodAf: null,
    vesselCodeBf: null,
    vesselCodeAf: null,
    voyageCodeBf: null,
    voyageCodeAf: null,
    applyCalendarAdjBf: null,
    applyCalendarAdjAf: null,
    splitFirstDaysBf: null,
    splitFirstDaysAf: null,
    splitFirstDaysToBf: null,
    splitFirstDaysToAf: null,
    splitRemainDaysToBf: null,
    splitRemainDaysToAf: null,
    rejectReasonBf: null,
    rejectReasonAf: null,
    remarksBf: null,
    remarksAf: null,
    graceExtendBf: null,
    graceExtendAf: null,
    activeIndBf: null,
    activeIndAf: null,
    draftDocNoBf: null,
    draftDocNoAf: null,
    docNoBf: null,
    docNoAf: null,
    receiptNoBf: null,
    receiptNoAf: null,
    auditLogType: null,
    auditLogIncident: null,
    updatedDateTime: null
}

